import { useRef } from 'react';
import { useOtherSettings } from '@namespace/cms';
import { useIsCritAllowedOnCurrentPage } from '../../hooks';
import { useNotificationCenterStore } from '../../store';
import { BellNotificationIcon } from '../BellNotificationIcon';
import { CriticalNotification } from '../CriticalNotification';
import { NotificationsList } from '../NotificationsList';

const NotificationCenterBare = () => {
  const { isNotificationsListOpened, criticalNotifications } =
    useNotificationCenterStore([
      'isNotificationsListOpened',
      'criticalNotifications'
    ]);
  const bellRef = useRef();
  const hasCriticals = criticalNotifications.length > 0;
  const isCritsAllowed = useIsCritAllowedOnCurrentPage();

  return (
    <>
      <BellNotificationIcon ref={bellRef} />
      {isNotificationsListOpened && (!hasCriticals || !isCritsAllowed) && (
        <NotificationsList bellRef={bellRef} />
      )}
      {hasCriticals && isCritsAllowed && <CriticalNotification />}
    </>
  );
};

export const NotificationCenter = () => {
  const { isNotificationCenterEnabled = false } = useOtherSettings();

  if (!isNotificationCenterEnabled) {
    return null;
  }

  return <NotificationCenterBare />;
};
